(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .controller('ProjectController', ProjectController);

    ProjectController.$inject = ['User', 'UserService', 'Project', 'ProjectStatusService', 'FileFactory', 'Cache', '$resource', '$state', '$timeout', '$mdDialog', 'toastHelper', '_', '$q', 'moment', 'jQuery', 'loadedManager', 'filesPerStep'];

    /* @ngInject */
    function ProjectController(User, UserService, Project, ProjectStatusService, FileFactory, Cache, $resource, $state, $timeout, $mdDialog, toastHelper, _, $q, moment, jQuery, loadedManager, filesPerStep) {
        var vm = this;
        vm.model = {
            loading: false,

            steps: {
                prev: {
                    name: '',
                    code: ''
                },
                current: {
                    name: '',
                    code: ''
                },
                next: {
                    name: '',
                    code: ''
                }
            },
            project: {},
            manager: {},
            user: {},
            selectedStepId: 1,
            managerFiles: [],
            clientFiles: [],
            viewFiles: []
        };
        var steps, stepStatuses, orderStatuses;

        vm.selectStep = selectStep;
        vm.fileSubmitted = fileSubmitted;
        vm.readFile = readFile;
        vm.canLoadFile = canLoadFile;
        vm.mustLoadFile = mustLoadFile;
        vm.showImgSlider = showImgSlider;
        vm.showNoFile = showNoFile;
        vm.showEmptyFile = showEmptyFile;
        vm.showReviewFile = showReviewFile;

        activate();

        ////////////////

        function activate() {
            vm.model.user = UserService.getUser();
            vm.model.loading = true;
            steps = ProjectStatusService.getSteps();
            stepStatuses = ProjectStatusService.getStepsStatuses();
            vm.model.abortStatuses = ProjectStatusService.getAbortStatuses();
            orderStatuses = ProjectStatusService.getOrderStatuses();


            _loadProject(UserService.getUser()['order_id'])
                .then(_getManager)
                .then(_getFiles)
                .then(function () {
                    vm.model.loading = false;
                    $timeout(function() {
                        var sliderSize = jQuery('#slider-size').outerWidth();
                        jQuery('#slider-wrap').width(jQuery('#slider-size').outerWidth());
                        jQuery('.lazy').slick({
                            lazyLoad: 'ondemand'
                        });
                        var slickFiles = jQuery('#files-slick');
                        if(vm.model.project.step_id > 6) {
                            jQuery('#files-slider-wrap').width(jQuery('#files-slider-size').outerWidth());
                            slickFiles.slick({
                                //centerMode: true,
                                infinite: false,
                                slidesToShow: 3,
                                slidesToScroll: 1,
                                initialSlide: vm.model.project.step_id
                            });
                        }
                    }, 800);
                })
                .catch(function (e) {
                    $state.go('profile');
                });
        }

        function showImgSlider() {
            return vm.model.project.step_id < steps[steps.length-1].code && vm.model.viewFiles.length > 0
        }

        function showNoFile() {
            return vm.model.project.step_id < steps[steps.length-1].code && vm.model.viewFiles.length == 0 && mustLoadFile()
        }

        function showEmptyFile() {
            return vm.model.project.step_id < steps[steps.length-1].code &&  vm.model.viewFiles.length == 0 && !mustLoadFile()
        }

        function showReviewFile() {
            return vm.model.project.step_id == steps[steps.length-1].code;
        }


        function selectStep(step_id) {
            vm.model.selectedStepId = step_id;
        }

        function canLoadFile() {
            return _.get(vm.model.project, 'status', '') == 1;
        }

        function mustLoadFile() {
            return _.get(vm.model.project, 'step.flag_doc', 0) == 1;
        }

        function _loadProject(projectId) {
            return Project.get({projectId: projectId})
                .$promise
                .then(function (response) {
                    return response.order;
                }, function () {
                    toastHelper.show('Ошибка: неизвестный проект!');
                    return $state.go('profile');
                })
                .then(function (project) {
                    project.date = moment(project.deadline, 'YYYY-MM-DD', true).isValid() ? moment(project.deadline, 'YYYY-MM-DD', true).toDate() : null;
                    project.step = _.find(steps, {id: project.step_id});
                    if (_.isUndefined(project.step)) {
                        toastHelper.show('Ошибка: неизвестный шаг проекта!');
                        return;
                    }
                    ProjectStatusService.defineStepAndStatus(project);
                    return vm.model.project = project;
                })
                .then(function() {
                    if(vm.model.project.prev_step_id != null && vm.model.project.prev_step_id != vm.model.project.step_id) {
                        vm.model.steps.prev = _.find(steps, {id: vm.model.project.prev_step_id});
                    }
                    vm.model.steps.current = _.find(steps, {id: vm.model.project.step_id});
                    if(vm.model.project.step_id < steps.length) {
                        vm.model.steps.next = _.find(steps, {id: vm.model.project.step_id+1});
                    }
                });
        }

        function fileSubmitted($flow) {
            vm.model.fileLoading = true;
            var dialog;
            var file = $flow.files[0].file;

            if(file.size > 9*1024*1024) {
                dialog = $mdDialog.alert({
                    title: 'Недопустимый размер файла!',
                    textContent: 'Достпуна загрузка документов размером не более 9 MB',
                    ok: 'ОК'
                });
                return $mdDialog
                    .show(dialog)
                    .finally(function () {
                        vm.model.fileLoading = false;
                        return $flow.files = [];
                    });
            }

            var fd = new FormData();
            fd.append("file", file);
            fd.append("order_id", vm.model.project.id);
            fd.append("step_id", vm.model.project.step_id);

            FileFactory.upload(fd)
                .$promise
                .then(function(res) {
                    toastHelper.show('Документ загружен!');
                    vm.model.fileLoading = false;
                    return _getFiles();
                }, function(res) {
                    toastHelper.show('Документ не загружен!');
                    vm.model.fileLoading = false;
                });
        }

        function readFile(item) {
            if(angular.isDefined(item.rtime) && item.rtime != null) {
                return;
            }
            var File = $resource('api/file/' + item.id+'/edit?code='+item.code);

            File.query()
                .$promise
                .then(function(res) {
                    return $q.resolve();
                }, function() {
                    return $q.resolve();
                })
                .catch(function() {
                    return $q.resolve();
                });
        }

        function _getFiles() {
            return  FileFactory.get({id: vm.model.project.id})
                .$promise
                .then(function(response) {
                    vm.model.clientFiles = _.get(response.cfile, 'object', []);
                    //vm.model.managerFiles =  _.get(response.mfile, 'object', []);
                    vm.model.managerFiles = _.groupBy( _.get(response.mfile, 'object', []), 'step_id');
                    if(!vm.model.managerFiles[vm.model.project.step_id]) {
                        vm.model.managerFiles[vm.model.project.step_id] = [{step_id: vm.model.project.step_id, code: 1}];
                    }
                    _.forEach(vm.model.managerFiles, function(files) {
                        var stepId = files[0].step_id;
                        var loaded = 0;
                        for(var i = 0; i <= filesPerStep[stepId].length; i++) {
                            var fps = _.find(filesPerStep[stepId], {'code': i});
                            if(fps) {
                                var f = _.find(files, {'code': i});
                                if (f) {
                                    f.fname = fps.name;
                                    if(f.file_link == null || f.file_link == '') {
                                        f.fname += ' (не загружен)';
                                    }
                                }
                            }

                            if(files[i] && files[i].file_link != null && files[i].file_link != '') {
                                loaded++;
                            }
                        }
                        _.sortBy(files, 'code');
                        files[0].step_name = _.find(steps, {'code': stepId}).name;
                        files[0].loaded = loaded;
                    });
                    if(_.size(vm.model.viewFiles) == 0) {
                        vm.model.viewFiles = _.get(response.mfile_ext, 'object', []);
                    }
                    return response
                }, function(response) {
                    vm.model.clientFiles = [];
                    vm.model.managerFiles = [];
                    vm.model.viewFiles = [];
                    return {};
                })
                .then(function(response) {
                    var defer = $q.defer();
                    var promises = [];

                    var users = _.union(_.map(_.get(response.mfile, 'object', []), 'cuser'), _.map(vm.model.clientFiles, 'cuser'));
                    users = _.filter(users, function(item) {
                        return item != null;
                    });

                    _.forEach(users, function (userId) {
                        promises.push(_getUser(userId));
                    });

                    $q.all(promises)
                        .then(function (resolutions) {
                            defer.resolve();
                        });

                    return defer.promise;
                })
                .then(function() {
                    _.forEach(vm.model.managerFiles, function (stepFiles) {
                        _.forEach(stepFiles, function(file) {
                            file.date = file.ctime ? moment(file.ctime, 'YYYY-MM-DD HH:mm::ss').format('DD.MM.YY') : '';
                            file.time = file.ctime ? moment(file.ctime, 'YYYY-MM-DD HH:mm::ss').format('HH:mm') : '';
                            if(file.rtime != null) {
                                file.readTime = moment(file.rtime, 'YYYY-MM-DD HH:mm::ss').format('DD.MM.YY HH:mm');
                            }
                            file.user_name = file.cuser ? Cache.get('u' + file.cuser).name : '';
                        });
                    });

                   /* _.forEach(vm.model.managerFiles, function(item) {
                        item.date = moment(item.ctime, 'YYYY-MM-DD HH:mm::ss').format('DD.MM.YY');
                        item.time = moment(item.ctime, 'YYYY-MM-DD HH:mm::ss').format('HH:mm');
                        item.step = _.find(steps,  {id: item.step_id});
                        item.user = Cache.get('u'+item.cuser);
                    });*/
                    _.forEach(vm.model.clientFiles, function(item) {
                        item.date = moment(item.ctime, 'YYYY-MM-DD HH:mm::ss').format('DD.MM.YY');
                        item.time = moment(item.ctime, 'YYYY-MM-DD HH:mm::ss').format('HH:mm');
                        item.step = _.find(steps,  {id: item.step_id});
                        item.user = Cache.get('u'+item.cuser);
                    });
                    vm.model.selectedStepId = vm.model.project.step_id;
                })
        }

        function _getUser(userId) {
            if (angular.isDefined(Cache.get('u' + userId))) {
                return $q.resolve(Cache.get('u' + userId));
            } else {
                return User.get({userId: userId})
                    .$promise
                    .then(function (response) {
                        return response.user;
                    }, function () {
                        return null;
                    })
                    .then(function (user) {
                        if (user != null) {
                            user.birthdate = moment(user.birthday, 'YYYY-MM-DD', true).isValid() ? moment(user.birthday, 'YYYY-MM-DD', true).toDate() : null;
                            user.avatar = UserService.getAvatar(user);
                            user.name = UserService.getName(user);
                            user.isClient = UserService.isClient(user);
                            Cache.put('u' + userId, user);
                        }
                        return user;
                    });
            }
        }

        function _getManager() {
            return _getUser(vm.model.project.manager_id)
                .then(function(user) {
                    vm.model.manager = user;
                });
        }
    }

})();

